import { render } from "./BaseTableHeader.vue?vue&type=template&id=812ef36e&scoped=true&ts=true"
import script from "./BaseTableHeader.vue?vue&type=script&lang=ts"
export * from "./BaseTableHeader.vue?vue&type=script&lang=ts"

import "./BaseTableHeader.vue?vue&type=style&index=0&id=812ef36e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812ef36e"]])

export default __exports__